function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (_ref) {
  var breakpoints = _ref.breakpoints,
    spacing = _ref.spacing;
  return {
    headerBox: function headerBox(_ref2) {
      var isUserAuthenticated = _ref2.isUserAuthenticated;
      if (!isUserAuthenticated) {
        return {
          margin: 'auto'
        };
      }
      return _defineProperty({
        display: 'flex',
        paddingLeft: spacing[3],
        paddingRight: spacing[3]
      }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
        flexGrow: 1,
        paddingLeft: 0,
        paddingRight: 0
      });
    },
    headerLink: function headerLink(_ref4) {
      var isUserAuthenticated = _ref4.isUserAuthenticated;
      if (!isUserAuthenticated) {
        return {};
      }
      return _defineProperty({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center'
      }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
        paddingLeft: spacing[7],
        paddingRight: spacing[7],
        justifyContent: 'flex-start'
      });
    },
    headerLogo: function headerLogo(_ref6) {
      var isUserAuthenticated = _ref6.isUserAuthenticated;
      if (!isUserAuthenticated) {
        return {};
      }
      return _defineProperty({
        paddingLeft: spacing[3],
        paddingRight: spacing[3]
      }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
        paddingLeft: 0,
        paddingRight: 0
      });
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map